import styled from 'styled-components';
import { ImageProps } from './types';

export const ImageBase = styled.img<ImageProps>`
  width: ${({ width }) => width};
  height: ${({ height }) => height};
`;
